import { createFileRoute } from '@tanstack/react-router'
import { InviteUserForm } from '@/src/components/manage/mutate/inviteUser'
import AdminToolbar from '@/src/components/layout/AdminToolbar'

export const Route = createFileRoute('/_manage/manage/admin/users/new')({
  component: InviteUserPage,
})

function InviteUserPage() {
  return (
    <div className="bg-background text-foreground">
      <AdminToolbar>
        <AdminToolbar.BackButton to="/manage/admin/users" />
      </AdminToolbar>
      
      <div className="mt-4">
        <InviteUserForm callbackUrl="/manage/admin/users" />
      </div>
    </div>
  )
}
